import styled from 'styled-components'
import { Modal } from 'antd'

export const BoldText = styled.p`
  font-weight: bold;
  ${''}
  margin-top: 5px;
  font-size: 20px;
  text-align: center;
`
export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const ExportButtonContainer = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: end;
  align-items: baseline;
`
export const CancelButtonContainer = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: start;
  align-items: baseline;
`
export const StyledModal = styled(Modal)`
  .ant-modal-content {
    ${''}
    width:max-content;
  }
  .ant-modal-title {
    ${''}
  }
  .ant-modal-header {
    ${''}
  }
  .ant-modal-close-x {
    ${''}
  }
  .ant-modal-close {
    display: none;
  }
  .ant-table-content .ant-checkbox {
    display: none;
  }
  .ant-modal-footer {
    display: none;
  }
  .ant-modal-body {
    padding: 40px;
    width: 800px;
  }
  .ant-table-thead {
    display: none;
  }

  .ant-table-cell.ant-table-selection-column {
    ${''}
  }
  .ant-transfer-list-header-selected + Span {
    display: flex;
    justify-content: flex-end;
  }
  .ant-transfer-list-header {
    margin-left: auto;
    height: 50px;
  }
  .ant-btn.ant-btn-primary.ant-btn-sm.ant-btn-icon-only {
    height: 51px !important;
    width: 65px !important;
  }

  .ant-transfer-operation .ant-btn .anticon {
    font-size: 24px;
  }
  .ant-transfer-operation {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    margin: 0px 16px;
    gap: 10px;
    padding: 25px;
    border: 1px solid #dadada;
    padding-top: 110px;
    padding-bottom: 100px;
  }
  ${''}

  .ant-transfer-list-header {
    margin-right: auto;
    width: 100%;
  }
  .ant-transfer-list-header-selected {
    text-align: center;
    width: 100%;
  }

  .ant-table-cell {
    border-bottom: 0px;
    cursor: pointer;
  }
  .ant-empty.ant-empty-normal {
    margin-top: 100px;
  }

  .ant-transfer-list-body {
    overflow-y: scroll;
    height: 380px;
  }

  .ant-transfer-list-body::-webkit-scrollbar {
    width: 8px;
  }
  .ant-transfer-list-body::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 10px;
  }
  .ant-table-row:hover .ant-table-cell {
    background-color: #ebecee;
  }
  .ant-table-tbody tr.ant-table-row-selected td {
    background: rgb(214, 219, 247);
  }
  .ant-transfer .ant-transfer-customize-list {
    position: relative;
  }
`
export const CenteredButtonsWrapper = styled.div`
  ${
    '' /* display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 40px;
  margin-bottom: 10px; */
  }
`
